import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/site/BrandLogo";

export const LegalLayout = ({ eyebrow, title, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="bg-greige min-h-screen text-[#2B2825]"
      style={{ fontFamily: "'Figtree', sans-serif" }}
      data-testid="legal-page"
    >
      <header className="mx-auto flex max-w-5xl items-center justify-between px-6 py-6 lg:px-0">
        <Link
          to="/"
          className="flex items-center no-underline"
          aria-label="DirektLab Startseite"
          data-testid="legal-brand-link"
        >
          <BrandLogo className="h-10 w-auto" />
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#6E685F] no-underline transition-colors hover:text-[#2B2825]"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={16} /> Zurück zur Startseite
        </Link>
      </header>

      <main className="mx-auto max-w-3xl px-6 pb-28 pt-12 lg:pt-20">
        <p className="eyebrow mb-6 text-[#6E685F]">{eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl" data-testid="legal-title">
          {title}
        </h1>
        <div className="legal-prose mt-12">{children}</div>
      </main>

      <footer className="border-t border-[#A39C90]/30">
        <div className="mx-auto flex max-w-5xl flex-col gap-2 px-6 py-8 text-xs text-[#6E685F] sm:flex-row sm:items-center sm:justify-between lg:px-0">
          <span>© 2026 DirektLab. Alle Rechte vorbehalten.</span>
          <span className="flex gap-6">
            <Link to="/impressum" className="no-underline text-[#6E685F] hover:text-[#2B2825]">
              Impressum
            </Link>
            <Link to="/datenschutz" className="no-underline text-[#6E685F] hover:text-[#2B2825]">
              Datenschutz
            </Link>
          </span>
        </div>
      </footer>
    </div>
  );
};
